import { promocodeNumber } from "./promocodeNumber.js";


function init() {
    promocodeNumber();
}

export {
    init   
}